import { PopularSearchTermSet } from '../../types';
import { MetaDataContext } from './types';

export default (
  { data }: { data: { popularSearchTerms: PopularSearchTermSet } },
  { t }: MetaDataContext
) => {
  const { keywords = [], categories = [] } = data?.popularSearchTerms || {};
  const categoryNames = categories.slice(0, 3).map(({ name }) => name);
  const keywordNames = keywords.slice(0, 3).map(({ name }) => name);
  const title = t('meta', 'keyword-listing.title', {
    category: categoryNames[0],
  });
  const description = t('meta', 'keyword-listing.description', {
    keyword: keywordNames.join(', '),
    categories: categoryNames.join(', '),
  });
  return {
    noIndex: true,
    follow: true,
    title,
    description,
  };
};
